<template>
	<dropdown :disabled="noItems" :label="label">
		<div v-if="showSearch" class="dropdown-item">
			<div class="field">
				<div class="control has-icons-left">
					<input
						v-model="searchText"
						class="input is-small"
						type="search"
						placeholder="Filter"
					/>
					<span class="icon is-left">
						<i class="fas fa-search"></i>
					</span>
				</div>
			</div>
		</div>
		<div v-if="isFiltered" class="dropdown-item">
			<b-checkbox
				:value="!selected.length"
				:class="{ 'show-all-items': !selected.length }"
				@change.native="(e) => clear(e)"
				>All {{ type }}s</b-checkbox
			>
		</div>
		<div v-if="filtered.length > 0">
			<div
				v-for="{ firstname, lastname, id } in filtered"
				:key="id"
				class="dropdown-item"
			>
				<b-checkbox
					v-model="selected"
					:native-value="id"
					@input="update"
					>{{ firstname }} {{ lastname }}</b-checkbox
				>
			</div>
		</div>
		<div v-if="noMatch" class="dropdown-item">
			<p>No match found for your filter</p>
		</div>
	</dropdown>
</template>

<script>
import multiMixin from "../multiMixin";
import Dropdown from "@shared/components/AppDropdown";
import { reduceUsers } from "@lab/utils/utilities";
import { mapActions, mapGetters } from "vuex";
import { orderBy } from "lodash";

export default {
	name: "UsersFilter",
	components: {
		Dropdown
	},
	mixins: [multiMixin],
	data() {
		return {
			type: "user",
			sortBy: ["firstname", "lastname"]
		};
	},
	computed: {
		...mapGetters({
			filterUsers: "reportFilters/users",
			selectedUsers: "reportQueries/users"
		}),
		items() {
			let users = this.filterUsers;
			users = reduceUsers(users);
			return orderBy(users, this.sortBy);
		}
	},
	watch: {
		items() {
			this.searchText = "";
		},
		selectedUsers(ids) {
			if (!ids.length) {
				this.selected = [];
			}
		}
	},
	beforeDestroy() {
		this.updateUsers([]);
	},
	methods: {
		...mapActions({
			updateUsers: "reportQueries/updateUsers"
		}),
		clear(e) {
			const checked = e.target.checked;
			if (checked) {
				this.selected = [];
			}
			this.updateUsers(this.selected);
		},
		update() {
			this.updateUsers(this.selected);
		},
		matched(search, item) {
			return (
				item.firstname.toLowerCase().includes(search) ||
				item.lastname.toLowerCase().includes(search)
			);
		}
	}
};
</script>

<style scoped>
.show-all-items {
	pointer-events: none;
}
.dropdown >>> .dropdown-menu {
	z-index: 3;
	width: 24rem;
	display: none;
}
.dropdown.is-active >>> .dropdown-menu {
	display: block;
}
.dropdown >>> .dropdown-content {
	max-height: 213px;
	overflow-y: auto;
}
</style>
